// Widget Scripts
import logoHeader from './js/widgets/logoHeader.js';
import swiperWidgetMainFeature from './js/widgets/swiperWidgetMainFeature.js';
import cardWidgetSecondFeature from './js/widgets/cardWidgetSecondFeature.js';
import cardWidgetThirdFeature from './js/widgets/cardWidgetThirdFeature.js';
import cardWidgetFourthFeature from './js/widgets/cardWidgetFourthFeature.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import emailSignupText from './js/widgets/emailSignupText.js';
import videoWidget from './js/widgets/videoWidget.js';
import alternativeSlideshowFeature from './js/widgets/alternativeSlideshowFeature.js';
import sponsors from './js/widgets/sponsors.js';
import logoFooter from './js/widgets/logoFooter.js';
import cardWidgetFooterCards from './js/widgets/cardWidgetFooterCards.js';




// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    swiperWidgetMainFeature();
    cardWidgetSecondFeature();
    cardWidgetThirdFeature();
    cardWidgetFourthFeature();
    emailSignupText();
    multiScheduleFeature();
    sponsors();

    $(window).load(function () {
      videoWidget();
      alternativeSlideshowFeature();

    })
  });
}
$(document).ready(function () {
  logoHeader();
  logoFooter()
  cardWidgetFooterCards();

});